import { createSlice } from '@reduxjs/toolkit';
import { STATUS_LOADING } from 'common/constants';

import { IState, STATE } from '../types/state';

import setActiveFuelCard from './setActiveFuelCard';
import setFuelCardsStatusLoading from './setFuelCardsStatusLoading';
import setFuelCards from './setFuelCards';

const initialState: IState = {
  fuelCards: {
    statusLoading: STATUS_LOADING.load,
    data: {},
    activeFuelCard: '',
  },
};

const slice = createSlice({
  name: STATE,
  initialState,
  reducers: {
    setFuelCards,
    setFuelCardsStatusLoading,

    setActiveFuelCard,
  },
});

export default slice;
